import { useFliptBoolean } from "@flipt-io/flipt-client-react";
import useUser from "~/contexts/user";

export function useTablePreviewFlag(): boolean {
  const user = useUser();
  // Default to true for all users as we roll out this feature
  return useFliptBoolean("snowflake-table-preview", true, user?.email);
}
